import {registrationApi} from 'common/api/entitiesApi'
import * as React from 'react'
import {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import './style.css'
import {Button, Form, Input, Layout, message} from 'antd';
import {MailOutlined} from '@ant-design/icons';
import { useUserContext } from 'common/context/UserContext.tsx'

const FormItem = Form.Item

export const ResetPasswordForm: React.FC = () => {
    const [isSuccess, setIsSuccess] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [error, setError] = useState<string | undefined>(undefined);
    const navigateTo = useNavigate()
    const [loading, setLoading] = useState(false)
    const [email, setEmail] = useState<string>('')
    const { logoDataURI } = useUserContext()

    const handleSubmit = () => {
        setLoading(true)
        registrationApi.resetPassword({name: '', email}).then(({success}) => {
            if (success) {
                setLoading(false)
                setIsSuccess(true)
                return
            }
            setError('Something went wrong, try again later')
            setLoading(false)
        }).catch(() => {
            setLoading(false)
        })
    }

    const errorMessage = () => {
        messageApi.open({
            type: 'error',
            content: error,
            duration: 5,
            style: {
                marginTop: '80px',
            },
        });
    };

    useEffect(() => {
        if (error) {
            errorMessage()
            setError(undefined);
        }
    }, [error]);

    return isSuccess ? (
        <Layout>
            {contextHolder}
            {logoDataURI && (
                <div className="auth-logo-wrapper">
                    <img src={logoDataURI} alt="Logo" className="auth-logo" />
                </div>
            )}
            <Form
                className={'sign-up-form'}
                onFinish={handleSubmit}
                layout="vertical"
            >
                <div style={{display: 'flex', justifyContent: 'center'}}>We have sent a letter to your email address</div>
                <FormItem
                    style={{
                        marginTop: '20px'
                    }}
                >
                    <Button
                        style={{
                            width: '195px',
                        }}
                        type="primary"
                        htmlType="button"
                        onClick={handleSubmit}
                        loading={loading}
                        disabled={loading}
                    >
                        Resend email
                    </Button>
                    <Button
                        style={{
                            width: '195px',
                            marginLeft: '10px'
                        }}
                        type="default"
                        htmlType="button"
                        onClick={() => navigateTo('/login')}
                    >
                        Go to Sign In
                    </Button>
                </FormItem>
            </Form>
        </Layout>
    ) : (
        <Layout>
            {contextHolder}
            {logoDataURI && (
                <div className="auth-logo-wrapper">
                    <img src={logoDataURI} alt="Logo" className="auth-logo" />
                </div>
            )}
            <Form
                className={'reset-password-form'}
                onFinish={handleSubmit}
                layout="vertical"
            >
                <FormItem
                    name="email"
                    rules={[{required: true, message: 'Please input Account email'}]}
                    // label="Email"
                    extra={'We will send you a link to reset your password'}
                >
                    <Input prefix={<MailOutlined style={{color: 'rgba(0,0,0,.25)'}}/>} placeholder="Email"
                           onChange={(e) => setEmail(e.target.value)}
                    />
                </FormItem>
                <FormItem
                    style={{
                        marginTop: '20px',
                    }}
                >
                    <Button
                        style={{
                            width: '195px',
                        }}
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        disabled={loading}
                    >
                        Next
                    </Button>
                    <Button style={{
                        width: '195px',
                        marginLeft: '10px'
                    }} type="default" htmlType="button" onClick={() => navigateTo('/login')}>Go to Sign In</Button>
                </FormItem>
            </Form>
        </Layout>
    )
}
